import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { clearForm, getForm, getFormInstance, getFormTemplate, updateFormInstance } from 'actions/templates';
import Redirect from 'components/Redirect/Redirect';
import DisplayFormResults from 'containers/FormTemplate/Display/DisplayFormResults';
import Moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import Block, { BlockContent, BlockWrapper } from 'UI/Elements/Block';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { translate } from '@haldor/ui';
import DateTime from '_class/DateTime';
var SingleForm = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function SingleForm(props) {
    var _this;
    _classCallCheck(this, SingleForm);
    _this = _callSuper(this, SingleForm, [props]);
    /* Lifecycle methods */
    _defineProperty(_this, "componentDidMount", function () {
      _this.props.getForm(_this.props.match.params.id).then(function () {
        _this.props.getFormTemplate(_this.props.form.formTemplateID).then(function () {
          _this.setState({
            loading: false
          });
        });
        if (_this.props.form.formInstances != null && _this.props.form.formInstances.length > 0) {
          var instanceId = _this.props.form.formInstances[0].id;
          _this.props.getFormInstance(instanceId);
        }
      });
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      _this.props.clearForm();
    });
    /* Events */
    _defineProperty(_this, "onInputSubmit", function (values) {
      return new Promise(function (resolve) {
        var data = _this.props.form.formInstances[0];
        data.fieldResults = values.fieldResults;
        data.status = values.status;
        _this.props.updateFormInstance(data).then(function () {
          resolve(1);
          _this.props.getFormInstance(data.id);
        });
      });
    });
    /* Render methods */
    _defineProperty(_this, "renderFormInstance", function (instance) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: instance.id,
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this.onInstanceClick(instance);
        }
      }, /*#__PURE__*/React.createElement(RowCell, null, instance.user.firstName, " ", instance.user.lastName), /*#__PURE__*/React.createElement(RowCell, {
        shrink: true
      }, instance.status == 'SUBMITTED' ? _this.props.translate('Submitted') : null));
    });
    _this.state = {
      loading: true
    };
    _this.services = {
      forms: true
    };
    return _this;
  }
  _inherits(SingleForm, _Component);
  return _createClass(SingleForm, [{
    key: "render",
    value: function render() {
      if (!this.services.forms) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      var _this$props = this.props,
        formTemplate = _this$props.formTemplate,
        form = _this$props.form,
        translate = _this$props.translate;
      var turnedIn = _toConsumableArray(this.props.form.formInstances).filter(function (x) {
        return x.status == 'SUBMITTED';
      }).length;
      var instance = null;
      if (this.props.form.formInstances.length > 0) {
        instance = this.props.form.formInstances[0];
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "container single-task"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("h1", {
        style: {
          marginBottom: '1rem'
        }
      }, form.title), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '1rem 0'
        }
      }, /*#__PURE__*/React.createElement("p", null, form.text)), /*#__PURE__*/React.createElement(BlockWrapper, {
        cols: "1"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(BlockContent, null, turnedIn > 0 && Moment().isAfter(form.dueDate) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, translate('Your answers')), /*#__PURE__*/React.createElement(DisplayFormResults, {
        instance: instance,
        fields: formTemplate.fields
      })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, translate('Answer')), /*#__PURE__*/React.createElement(InputFormTemplate, {
        form: 'cm-' + formTemplate.id,
        fields: formTemplate.fields,
        onSubmit: this.onInputSubmit
      })))))), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, translate('Information')), /*#__PURE__*/React.createElement("div", null, turnedIn > 0 ? translate('Submitted') : translate('Not submitted'))), form.dueDate != null ? /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, translate('Turn in before')), new DateTime(form.dueDate).getLongDate()) : null, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, Moment().isBefore(form.dueDate) && turnedIn < 1 ? /*#__PURE__*/React.createElement("span", null) : null)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    formTemplate: state.Templates.formTemplate,
    form: state.Templates.form,
    instance: state.Templates.instance,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getFormTemplate: getFormTemplate,
  getForm: getForm,
  updateFormInstance: updateFormInstance,
  getFormInstance: getFormInstance,
  clearForm: clearForm
})(SingleForm);